import React, { useState, useRef, useEffect } from 'react';
import Header from './gapsy-header';
import Navigation from './gapsy-Anavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import dropdownStyles from '../assets/css/gapsy-download-dropdown.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import '../assets/css/gapsybdmupload.css';
import '../assets/css/TemplateForm.css';
import '../assets/css/Operators.css';
import '../assets/css/DEMchecker.css';
import axios from 'axios';
import * as XLSX from 'xlsx';
import '../assets/css/RDMupload.css';
import '../assets/css/style.css';
import '../assets/css/AdminautoBDM.css';
import { FbcDepartmentDropdown } from "../components/Dropdown";
import { Modal, Button, Form, Dropdown, DropdownButton, FaChevronDown } from 'react-bootstrap';
import { BackButton, PreViewButton, previewButtonStyle, UploadButtonStyle, bootstrapbuttonclass, cancelButtonStyle, submitButtonStyle, closeButtonStyle, HeadingStyle, h1, h2, h3, h4, h5, h6, h7, UploadLoadingIcon } from "../components/Propertyfile";
import { upload3001, UploadDemtemplate, Uploadtemplate, PortURL, dropdownlist, ListAlldept, userWisedept } from '../components/ApiProperty';
import tableStyles from '../assets/css/sharedTableStyles.module.css';
import { useSession } from '../components/SessionContext';


const GapsyFbc = () => {
    const [selectedFormat, setSelectedFormat] = useState("");
    const [previewData, setPreviewData] = useState([]); // State for preview data
    const [selectedName, setSelectedName] = useState('');
    const [isDragging, setIsDragging] = useState(false);
    const fileInputRef = useRef(null);
    let csrfToken = sessionStorage.getItem("tokenizedSession");
    const [selectedFile, setSelectedFile] = useState(null);

    const [showModal, setShowModal] = useState(false); // State to control modal visibility
    const [showNoDataModal, setShowNoDataModal] = useState(false);

    const [file, setFile] = useState(null);
    const [uploadStatus, setUploadStatus] = useState('');

    const [uploadSuccess, setUploadSuccess] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [loading, setLoading] = useState(false);

    const [showNotifyModal, setShowNotifyModal] = useState(false); // State to control notification modal visibility
    const location = useLocation();
    const [modalMessage, setModalMessage] = useState('');
    const [errorModalMessage, setErrorModalMessage] = useState('');
    const [showErrorModal, setShowErrorModal] = useState(false);

    const [departments, setDepartments] = useState([]);
    const [selectedDept, setSelectedDept] = useState("");
    const [showFileSelectionModal, setShowFileSelectionModal] = useState(false);
    const [fileSelectionMessage, setFileSelectionMessage] = useState('');
    const [isUploadAllowed, setIsUploadAllowed] = useState(true);
    const [isExactName, setExactName] = useState('');
    const [isaftersheetname, setaftersheetname] = useState('');
    const [showSecondModal, setShowSecondModal] = useState(false);
    const [messageType, setMessageType] = useState(''); // 'success' or 'error'
    const [secondModalMessage, setSecondModalMessage] = useState('');
    const [previewLimit, setPreviewLimit] = useState(100);
    const [dropdownValues, setDropdownValues] = useState([]);

    const [importRow, setImportRow] = useState(1);
    const [includeHeaders, setIncludeHeaders] = useState(true);

    const [showDownloadButton, setShowDownloadButton] = useState(false);
    const [showSheetDropdown, setShowSheetDropdown] = useState(false);


    const [selectedSheet, setSelectedSheet] = useState("");
    const [worksheets, setWorksheets] = useState([]); // Stores worksheet names
    const [selectedMicrosoftFormat, setSelectedMicrosoftFormat] = useState("");
    const [showTextDropdown, setShowTextDropdown] = useState(false);
    const [showOtherDropdown, setShowOtherDropdown] = useState(false);
    const [selectedTextFormat, setSelectedTextFormat] = useState("");
    const [selectedOtherFormat, setSelectedOtherFormat] = useState("");
    const [sheetData, setSheetData] = useState({});   // Stores extracted data for each sheet

    const [showMicrosoftDropdown, setShowMicrosoftDropdown] = useState(false);

    const [errorMessage, setErrorMessage] = useState(""); // State for error messages




    const department = sessionStorage.getItem("dept");

    localStorage.setItem('selectedDept', selectedDept);

    const handleCloseNoDataModal = () => setShowNoDataModal(false);
    const [selectedTableName, setSelectedTableName] = useState(null);

    const queryParams = new URLSearchParams(location.search);
    const tableName = queryParams.get('tableName');
    const [dangerCount, setDangerCount] = useState(0); // Count of rows with table-danger class

    const handleBrowseClick = (event) => {
        event.preventDefault();
        fileInputRef.current.click();
        setShowModal(false);
    };

    const navigate = useNavigate();
    if (!localStorage.getItem('userid')) {
        navigate('/404page');
    }

    const handlePreviewOption = () => {
        if (previewData.length > 0) {
            setShowModal(true);
        } else {
            setShowNoDataModal(true);
        }
    };



    const handleFileDrop = (e) => {
        const file = e.dataTransfer.files[0];
        if (file) setSelectedFile(file);
    };



    const handleCloseModal = () => {
        setShowModal(false);
    }

    const handleUpload = () => {
        alert(`Uploading file: ${selectedFile.name}`);
    };

    const formatMapping = {
        "Microsoft Excel": "excel",
        "Text Files": "text",
        "MySQL": "mysql"
    };

    const currentFormatKey = formatMapping[selectedFormat];


    const toTitleCase = (str) => {
        return str
            // Replace underscores or hyphens with spaces
            .replace(/[_-]/g, ' ')
            // Add space before capital letters (for camelCase)
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            // Capitalize first letter of each word
            .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
    };
   
    useEffect(() => {
        const fetchUserDepartments = async () => {
            if (selectedFile) {
                try {
                    let config = {
                        headers: {
                            "userId": localStorage.getItem('userid'), "x-csrf-token": csrfToken
                        },
                        withCredentials: true,
                    };
                    // const response = await axios.post('http://172.16.119.156:8081/api/dept/userwise', {}, config);
                    const response = await axios.post(userWisedept, {}, config);

                    if (response.data?.department && Array.isArray(response.data.department)) {
                        setDepartments(response.data.department.map((name, index) => ({
                            id: index + 1,
                            name
                        })));
                    } else {
                        console.error('Unexpected department data structure:', response.data);
                        setDepartments([]);
                    }
                } catch (error) {
                    console.error('Error fetching departments:', error);
                    setDepartments([]);
                }

            };
        }
        fetchUserDepartments();
    }, [selectedFile]);

    const getAllDropdownValues = async () => {
        try {
            let config = {
                headers: {
                    "adminId": localStorage.getItem('userid'), "x-csrf-token": csrfToken
                },
                withCredentials: true,
            };
            const response = await axios.post(dropdownlist, {}, config);

            // Ensure response is an array and then set state
            if (Array.isArray(response.data.master_table_info)) {
                setDropdownValues(response.data.master_table_info); // Proper state update
            }
        } catch (error) {
            console.error("Error fetching dropdown values:", error);
            setDropdownValues([]); // Ensure to set an empty array on error
        }
    };

    useEffect(() => {
        // This will run when `dropdownValues` is updated
        getAllDropdownValues();
    }, []); // Dependency array ensures this runs when `dropdownValues` changes

    const handleError = (message) => {
        setErrorModalMessage(message);
        setShowErrorModal(true);
        handleClearFile();
    };


    const validateXMLRow = (colFunctions, dropdownValues, rowIndex, colname) => {
        if (!colFunctions || colFunctions.trim() === '') {
            return null; // No issue
        }

        if (/\bdropdown\s*\([^)]*$/.test(colFunctions)) {
            return `Missing closing parenthesis in dropdown function at <strong>Row ${rowIndex + 2}</strong>`;
        }

        const matches = colFunctions.match(/dropdown\(([^)]+)\)/g);
        if (!matches || matches.length === 0) {
            return null; // No dropdown keyword, no issue
        }

        const columnsToValidate = matches.map(match =>
            match.replace(/dropdown\(|\)/g, '').trim()
        );

        const invalidColumns = columnsToValidate.filter(
            col => !dropdownValues.some(value =>
                value.master_table_name?.toLowerCase().trim() === col.toLowerCase().trim() ||
                value.col_name?.toLowerCase().trim() === col.toLowerCase().trim()
            )
        );


        if (invalidColumns.length > 0) {
            setShowNoDataModal(false);
            return `Invalid dropdown values (${invalidColumns.join(', ')}) found in Column ${colname}`;

        }

        return null; // No errors
    };

    const handleFormatSelection = (format) => {
        setSelectedFormat(format);
        // setSelectedMicrosoftFormat(""); // Reset selected format to empty
        setShowDownloadButton(true);
    };

    useEffect(() => {
        // This will run when `dropdownValues` is updated
        getAllDropdownValues();
    }, []); // Dependency array ensures this runs when `dropdownValues` changes
  

    const validateRow = (colFunctions, dropdownValues, columnName) => {
        if (!columnName) {
            console.warn("validateRow: columnName is undefined or empty");
            return `Column name is missing for validation.`;
        }

        const safeColumnName = columnName.trim();
        const formattedColumnName = toTitleCase(safeColumnName);

        if (!colFunctions || typeof colFunctions !== "string" || colFunctions.trim() === "") {
            return null; // No issue
        }

        if (/\bdropdown\s*\([^)]*$/.test(colFunctions)) {
            return `Column <strong>${formattedColumnName}</strong> has an invalid dropdown function (Missing closing parenthesis)`;
        }

        const matches = colFunctions.match(/dropdown\(([^)]+)\)/g);
        if (!matches || matches.length === 0) {
            return null; // No dropdown keyword, no issue
        }

        const columnsToValidate = matches.map(match => match.replace(/dropdown\(|\)/g, "").trim());

        const invalidColumns = columnsToValidate.filter(
            col => !dropdownValues.some(value => value.col_name?.toLowerCase().trim() === col.toLowerCase().trim())
        );

        if (invalidColumns.length > 0) {
            const formattedColumnName = toTitleCase(safeColumnName);
            const formattedInvalidValues = invalidColumns.map(toTitleCase).join(", ");


            return `Invalid dropdown value(s) <strong>${formattedInvalidValues}</strong> found in Column <strong>${formattedColumnName}</strong>`;
        }

        return null; // No errors
    };

    const parseCSVLine = (line) => {
        const result = [];
        let inQuotes = false;
        let value = '';

        for (let i = 0; i < line.length; i++) {
            const char = line[i];
            if (char === '"' && line[i + 1] === '"') {
                value += '"'; // Handle escaped quotes like ""
                i++;
            } else if (char === '"') {
                inQuotes = !inQuotes; // Toggle in/out of quotes
            } else if (char === ',' && !inQuotes) {
                result.push(value);
                value = '';
            } else {
                value += char;
            }
        }
        result.push(value);
        return result;
    };

    const convertCsvToTxt = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (event) => {
                try {
                    const csvContent = event.target.result;
                    const rows = csvContent.split('\n').filter(row => row.trim() !== '');

                    if (rows.length === 0) {
                        setShowNoDataModal(true);
                        setIsUploadAllowed(false);
                        return reject(new Error('No content in file'));
                    }

                    const fileName = file.name.split('.')[0];
                    const filenames = toTitleCase(fileName);

                    // Use same validation: only lowercase, numbers, underscores
                    const validSheetNameRegex = /^[a-z0-9_]+$/;

                    if (!validSheetNameRegex.test(fileName)) {
                        setModalMessage(
                            `Only lowercase letters, numbers, and underscores are allowed. Spaces or other special characters are not allowed.`
                        );
                        setMessageType('danger');
                        setShowNotifyModal(true);
                        setIsUploadAllowed(false);
                        return reject(new Error('Invalid sheet name'));
                    }



                    const rawHeaders = parseCSVLine(rows[0]).map(value => value.trim().replace(/^"(.*)"$/, '$1'));

                    const upperHeaders = rawHeaders.map(h => h.toUpperCase());

                    const expectedRawHeaders = [
                        'COLUMN_NAME',
                        'COLUMN_TYPE',
                        'COLUMN_LENGTH',
                        'COLUMN_LABEL',
                        'COLUMN_KEY',
                        'COLUMN_FUNCTIONS'
                    ];

                    const invalidHeaders = upperHeaders.filter(h => !expectedRawHeaders.includes(h));


                    if (invalidHeaders.length > 0 || upperHeaders.length !== expectedRawHeaders.length) {
                        // setModalMessage('Invalid (or) Incorrect Columns Identified. Ensure to have the following Headers:\n\n' + expectedRawHeaders.join(', '));
                        const errorMessage = `Invalid (or) Incorrect Columns Identified. Ensure to have the following Headers:<br/>${expectedRawHeaders.join(', ')}`;
                        setModalMessage(errorMessage);
                        setMessageType('danger');
                        setShowNotifyModal(true);
                        setIsUploadAllowed(false);
                        setSelectedFile(null);
                        handleCancel();
                        return reject(new Error('Invalid columns in CSV'));
                    }

                    const headerAliasMapping = {
                        'COLUMN_NAME': 'col_name',
                        'COLUMN_TYPE': 'col_type',
                        'COLUMN_LENGTH': 'col_length',
                        'COLUMN_LABEL': 'col_label',
                        'COLUMN_KEY': 'col_key',
                        'COLUMN_RENAME': 'col_rename',
                        'COLUMN_ACTIVE': 'col_active',
                        'COLUMN_FUNCTIONS': 'col_functions'
                    };


                    const headers = upperHeaders.map(header => headerAliasMapping[header] || header);

                    const colKeyIndex = headers.indexOf('col_key');
                    const previewHeaders = upperHeaders;

                    const allowedColumns = ['col_name', 'col_type', 'col_length', 'col_label', 'col_key', 'col_rename', 'col_active', 'col_functions'];
                    const mandatoryColumns = ['col_name', 'col_type', 'col_label', 'col_functions', 'col_length'];
                    const missingColumns = mandatoryColumns.filter(col => !headers.includes(col));
                    const misspelledColumns = headers.filter(col => !allowedColumns.includes(col) && col.trim() !== '');

                    let errors = [];

                    const errorMessages = [];


                    if (missingColumns.length > 0) {
                        const formattedMissing = missingColumns.map(col => toTitleCase(col));
                        errors.push(`Missing Column(s): <strong>${formattedMissing.join(', ')}</strong>`);
                    }

                    if (misspelledColumns.length > 0) {
                        const formattedMisspelled = misspelledColumns.map(col => toTitleCase(col));
                        errors.push(`Mispelled Column(s): <strong>${formattedMisspelled.join(', ')}</strong>`);
                    }


                    const colFunctionIndex = headers.indexOf('col_functions');
                    const colTypeIndex = headers.indexOf('col_type');
                    const colNameIndex = headers.indexOf('col_name');
                    const colLabelIndex = headers.indexOf('col_label');
                    const colLengthIndex = headers.indexOf('col_length');

                    if (colFunctionIndex === -1) errors.push('"COLUMN_FUNCTIONS" column not found');
                    if (colTypeIndex === -1) errors.push('"COLUMN_TYPE" column not found');
                    if (colNameIndex === -1) errors.push('"COLUMN_NAME" column not found');
                    if (colLabelIndex === -1) errors.push('"COLUMN_LABEL" column not found');
                    if (errors.length > 0) {
                        const combinedErrorMessage =
                            errors.length > 1 ? errors.slice(0, -1).join('\n') + ' and ' + errors.slice(-1) : errors[0];

                        setModalMessage(combinedErrorMessage);
                        setMessageType('danger');
                        setShowNotifyModal(true);
                        setIsUploadAllowed(false);
                        setSelectedFile(null);
                        handleCancel();
                        return reject(new Error(combinedErrorMessage));
                    }


                    let primaryKeyCount = 0;
                    let reportingDateAsPrimaryKey = false;
                    let invalidColKeyErrors = [];
                    const invalidColumnNames = new Set(); // To track already reported invalid column names

                    rows.slice(1).forEach((row, rowIndex) => {
                        const columns = [];
                        let value = '', inQuotes = false;

                        // Parse the row into columns
                        for (let i = 0; i < row.length; i++) {
                            const char = row[i];
                            if (char === '"' && row[i + 1] === '"') {
                                value += '"'; i++;
                            } else if (char === '"') {
                                inQuotes = !inQuotes;
                            } else if (char === ',' && !inQuotes) {
                                columns.push(value.trim().replace(/^"(.*)"$/, '$1'));
                                value = '';
                            } else {
                                value += char;
                            }
                        }

                        columns.push(value.trim().replace(/^"(.*)"$/, '$1'));

                        const colLength = columns[colLengthIndex]?.trim();
                        const colTypeRaw = columns[colTypeIndex] || '';
                        const colTypeLower = colTypeRaw.trim().replace(/^"(.*)"$/, '$1').toLowerCase();
                        const formattedName2 = toTitleCase(colTypeLower);
                        const colName = columns[colNameIndex]?.trim();

                        // Validation for column type
                        const allowedTypes = ['int', 'varchar', 'date', 'double', 'boolean', 'decimal', 'float', 'char', 'datetime'];
                        const formattedName = toTitleCase(colTypeRaw);
                        const formattedName1 = toTitleCase(colName);
                        if (colTypeLower && !allowedTypes.includes(colTypeLower)) {
                            const err = `Invalid (or) Incorrect COLUMN_TYPE <strong>${formattedName}</strong> found in <strong>Row ${rowIndex + 2}</strong> (${formattedName1})`;
                            if (!errorMessages.includes(err)) errorMessages.push(err);
                        }

                        // Check if column name is valid
                        if (colName && (!colTypeLower || colTypeLower === '')) {
                            errorMessages.push(`COLUMN_NAME <strong>${formattedName1}</strong> requires the COLUMN_TYPE.`);
                        }

                        // Only numeric allowed for int, varchar, number
                        if (['int', 'varchar'].includes(colTypeLower)) {
                            if (!colLength || isNaN(colLength)) {
                                errorMessages.push(`COLUMN_LENGTH must be <strong>Number</strong> for COLUMN_TYPE <strong>${formattedName2}</strong> in at <strong>Row ${rowIndex + 2}</strong> (${formattedName1}).`);
                            }
                        }

                        if (colTypeLower === 'date') {
                            if (colLength && colLength.trim() !== '') {
                                errorMessages.push(`COLUMN_LENGTH should be <strong>Blank<strong> for COLUMN_TYPE <strong>Date</strong> at <strong>Row ${rowIndex + 2}</strong> (${formattedName1}).`);
                            }
                        }

                         if (colTypeLower === 'datetime') {
                            if (colLength && colLength.trim() !== '') {
                                errorMessages.push(`COLUMN_LENGTH should be <strong>Blank<strong> for COLUMN_TYPE <strong>Datetime</strong> at <strong>Row ${rowIndex + 2}</strong> (${formattedName1}).`);
                            }
                        }

                        // Check for precision and scale for decimal, float, and double
                        if (['decimal', 'float', 'double'].includes(colTypeLower)) {
                            if (!colLength || /^\d+$/.test(colLength)) {
                                errorMessages.push(`COLUMN_TYPE must be <strong>precision,scale</strong> (eg: 18,2) for COLUMN_TYPE <strong>${formattedName2}</strong> at <strong>Row ${rowIndex + 2}</strong> (${formattedName1}).`);
                            } else {
                                const parts = colLength.split(',').map(p => p.trim());
                                if (parts.length !== 2 || parts.some(p => isNaN(p) || p === '')) {
                                    errorMessages.push(`COLUMN_TYPE must be <strong>precision,scale</strong> (eg: 18,2) for COLUMN_TYPE <strong>${formattedName2}</strong> at <strong>Row ${rowIndex + 2}</strong> (${formattedName1}).`);
                                } else {
                                    const [precision, scale] = parts.map(Number);
                                    if (scale > precision) {
                                        errorMessages.push(`COLUMN_TYPE <strong>${formattedName2}</strong> in (${formattedName1}) at <strong>Row ${rowIndex + 2}</strong>, scale (${scale}) should not be greater than precision <strong>(${precision})</strong>.`);
                                    }
                                }
                            }
                        }

                        // Set to track invalid column names to prevent duplicate error messages
                        if (colName && !/^[A-Za-z0-9_]+$/.test(colName)) {
                            // Only log the error once for each invalid column name
                            if (!invalidColumnNames.has(colName)) {
                                errorMessages.push(`Invalid (or) Incorrect COLUMN_NAME <strong>${formattedName1}</strong> at <strong>Row ${rowIndex + 2}</strong>. Letters (A-Z, a-z), Numbers (0-9), and Underscores (_) are only allowed`);
                                invalidColumnNames.add(colName); // Mark this column name as already logged
                            }
                        }

                        // Disallow characters in col_length
                        if (colLength && /[a-zA-Z]/.test(colLength)) {
                            errorMessages.push(`COLUMN_LENGTH should not contain Characters in Column <strong>${formattedName1}</strong> at <strong>Row ${rowIndex + 2}</strong>.`);
                        }

                        const dropdownValidationError = validateRow(columns[colFunctionIndex], dropdownValues, columns[colNameIndex]);
                        if (dropdownValidationError) errorMessages.push(dropdownValidationError);
                        // =============================================================
                        // Validate COLUMN_FUNCTIONS (generic – ANY function name)
                        // =============================================================
                        if (columns[colFunctionIndex]) {
                            const functionText = columns[colFunctionIndex].trim();

                            // Remove dropdown() from processing
                            const cleaned = functionText.replace(/dropdown\(([^)]*)\)/gi, "");

                            // Match all other functions
                            const functionMatches = cleaned.match(/\b([A-Za-z0-9_]+)\s*\(([^)]*)\)/gi);

                            if (functionMatches) {

                                const definedColumnNames = new Set();
                                rows.slice(1).forEach(r => {
                                    const parts = parseCSVLine(r);
                                    const colName = parts[colNameIndex]?.trim().toLowerCase();
                                    if (colName) definedColumnNames.add(colName);
                                });

                                functionMatches.forEach(fn => {
                                    const inside = fn.substring(fn.indexOf("(") + 1, fn.lastIndexOf(")")).trim();

                                    const referencedCols = inside
                                        .split(",")
                                        .map(c => c.trim().toLowerCase())
                                        .filter(c => c.length > 0);

                                    referencedCols.forEach(ref => {
                                        if (!definedColumnNames.has(ref)) {
                                            errorMessages.push(
                                                `Invalid column <strong>${ref}</strong> found in <strong>${fn}</strong> at <strong>Row ${rowIndex + 2}</strong>.`
                                            );
                                        }
                                    });
                                });
                            }
                        }


                        // Handle primary key logic
                        const colKeyValue = columns[colKeyIndex]?.toLowerCase();
                        if (colKeyValue === 'primary key') {
                            primaryKeyCount++;
                            if (columns[colNameIndex]?.toLowerCase() === 'reporting_date') {
                                reportingDateAsPrimaryKey = true;
                            }
                        }

                        if (
                            columns[colNameIndex]?.toLowerCase() === "reporting_date" &&
                            (colKeyValue.toLocaleLowerCase() === "null" || colKeyValue.toLowerCase() === "not null" || colKeyValue.toLowerCase() === "")
                        ) {
                            invalidColKeyErrors.push(`<strong>Reporting Date</strong> must be the Primary Key Column.`);
                        }
                    });


                    if (invalidColKeyErrors.length > 0) {
                        errorMessages.push(...invalidColKeyErrors);
                    }

                    if (primaryKeyCount === 0) {
                        errorMessages.push('No <strong>Primary Key</strong> Column found in the Template.');
                    }
                    // if (reportingDateAsPrimaryKey && primaryKeyCount === 1) {
                    //     errorMessages.push('Include an additional <strong>Primary Key</strong> Column, other than Reporting Date');
                    // }

                    if (errorMessages.length > 0) {
                        const combinedErrorMessage =
                            errorMessages.length > 1 ? errorMessages.slice(0, -1).join('\n') + ' and ' + errorMessages.slice(-1) : errorMessages[0];

                        setModalMessage(combinedErrorMessage);
                        setMessageType('danger');
                        setShowNotifyModal(true);
                        setIsUploadAllowed(false);
                        handleCancel();
                        return reject(new Error(combinedErrorMessage));
                    }

                    if (!reportingDateAsPrimaryKey) {
                        setModalMessage("COLUMN_NAME <strong>Reporting Date</strong> is missing. Include if it's Required.");
                        setMessageType('warning');
                        setShowNotifyModal(true);
                        setIsUploadAllowed(true);
                    }


                    const txtContent = rows.slice(1).map(row => {
                        const columns = parseCSVLine(row).map(value => value.trim().replace(/^"(.*)"$/, '$1'));

                        const rowObj = {};
                        headers.forEach((header, idx) => {
                            rowObj[header] = columns[idx] ?? '';
                        });

                        // Ensure col_rename and col_active are inserted as empty if missing
                        rowObj['col_rename'] = rowObj['col_rename'] || '';
                        rowObj['col_active'] = rowObj['col_active'] || '';

                        // Store col_functions value and temporarily remove it
                        const colFunctionsValue = rowObj['col_functions'] || '';
                        delete rowObj['col_functions'];

                        // Build the output row excluding col_functions first
                        const outputRow = [
                            rowObj['col_name'] || '',
                            rowObj['col_type'] || '',
                            rowObj['col_length'] || '',
                            rowObj['col_label'] || '',
                            rowObj['col_key'] || '',
                            rowObj['col_rename'],
                            rowObj['col_active']
                        ];

                        // Add col_functions at the end
                        outputRow.push(colFunctionsValue);

                        return outputRow.join('|');
                    }).join('\n');


                    const output = txtContent;
                    const hiddenColumns = ['col_rename', 'col_active'];

                    const previewHeaderFiltered = rawHeaders
                        .map(h => h.trim().replace(/^"(.*)"$/, '$1').toUpperCase())
                        .filter(h => {
                            const alias = headerAliasMapping[h.toUpperCase()];
                            return !hiddenColumns.includes(alias);
                        });


                    const previewData = rows.slice(1).map(row => {
                        const values = parseCSVLine(row).map(value => value.trim().replace(/^"(.*)"$/, '$1'));

                        const rowObj = {};
                        headers.forEach((alias, idx) => {
                            rowObj[alias] = values[idx] ?? '';
                        });

                        return previewHeaderFiltered.map(originalHeader => {
                            const alias = headerAliasMapping[originalHeader.toUpperCase()];
                            return rowObj[alias] || '';
                        }).join('|');

                    });



                    setPreviewData([previewHeaderFiltered.join('|'), ...previewData]);
                    setIsUploadAllowed(true);
                    resolve(output);

                } catch (error) {
                    handleError('Error processing file');
                    setIsUploadAllowed(false);
                    handleCancel();
                    reject(new Error('Error processing file'));
                }
            };

            reader.onerror = () => {
                handleError('Error reading file');
                setIsUploadAllowed(false);
                handleCancel();
                reject(new Error('Error reading file'));
            };

            reader.readAsText(file);
        });
    };

    const anotherFunction = (event) => {
        const Customfilename = event.target.files[0];
        setExactName(Customfilename.name);
    };

    const handleFileChange = async (event) => {
        const selectedFile = event.target.files[0];

        if (!selectedFile) return;

      
        const fileName = selectedFile.name.toLowerCase();
        const fileType = selectedFile.type || '';

        // Identify file types

        const isTxt = fileName.endsWith('.txt');
        const isCsv = fileType === 'text/csv' || fileName.endsWith('.csv');
        let isTsv = fileType === 'text/tab-separated-values' || fileName.endsWith('.tsv');
        let isPsv = fileName.endsWith('.psv');
        const isXls = (
            fileType === 'application/vnd.ms-excel' ||
            fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
            fileName.endsWith('.xls') ||
            fileName.endsWith('.xlsx') ||
            fileName.endsWith('.xlsb') ||
            fileName.endsWith('.xlsm') ||
            fileName.endsWith('.xltx')
        );
        const isSql = fileName.endsWith('.sql');

        if (isTxt) {

            try {
                const fileContent = await selectedFile.text();

                if (fileContent.includes('\t')) {
                    isTsv = true;
                } else if (fileContent.includes('|')) {
                    isPsv = true;
                } else {
                }
            } catch (error) {
                console.error(" Error reading .txt file:", error);
                return;
            }
        }

        // Validate file type
        if (!isCsv && !isTsv && !isPsv && !isXls && !isSql) {
            setUploadStatus('❌ Only CSV, TSV, PSV, SSV, XLS/XLSX, XML, JSON, XBRL, or SQL files are allowed.');
            setFile(null);
            setSelectedFile(null);
            setIsUploadAllowed(false);
            return;
        }

        setSelectedFile(selectedFile);
        if (isXls) {
            const { sheetNames, sheetsData } = await extractWorksheets(selectedFile);
            setWorksheets(sheetNames); // Update available sheets
            setSheetData(sheetsData);  // Store extracted data
        }


        try {
            setLoading(true);
            setErrMsg('');
            setIsUploadAllowed(true);

            let processedContent;
            let convertedFile = selectedFile;


            if (isTsv) {
                const tsvContent = await convertedFile.text();

                const lines = tsvContent.split('\n').map(line => {
                    const cells = line.split('\t').map(cell => {
                        const trimmed = cell.trim().replace(/"/g, '""');
                        // Wrap only if value contains a comma or quote
                        return (trimmed.includes(',') || trimmed.includes('"')) ? `"${trimmed}"` : trimmed;
                    });
                    return cells.join(',');
                });

                const csvContent = lines.join('\n');

                convertedFile = new File([csvContent], fileName.replace(/\.txt$/, '.csv'), { type: 'text/csv' });

                processedContent = await convertCsvToTxt(convertedFile);
            }

            if (isPsv) {
                const psvContent = await convertedFile.text();
                const lines = psvContent.split('\n');

                const csvLines = lines.map(line => {
                    const cells = line.split('|').map(cell => {
                        const trimmed = cell.trim();
                        if (trimmed.includes(',') || trimmed.includes('"')) {
                            return `"${trimmed.replace(/"/g, '""')}"`; // Escape quotes and wrap in double quotes
                        }
                        return trimmed;
                    });
                    return cells.join(',');
                });

                const csvContent = csvLines.join('\n');
                convertedFile = new File(
                    [csvContent],
                    fileName.replace(/\.txt$/, '.csv'),
                    { type: 'text/csv' }
                );
                processedContent = await convertCsvToTxt(convertedFile);
            }
            else if (isCsv) {
                processedContent = await convertCsvToTxt(convertedFile);

            } else if (isSql) {
                processedContent = await convertSqlToTxt(convertedFile);
            }
            const processedFile = new File(
                [processedContent],
                fileName.replace(/\.(csv|tsv|psv|ssv|xls|xlsx|xml|json|xbrl|sql)$/, '.txt'),
                { type: 'text/plain' }
            );
            setFile(processedFile);
            setUploadStatus('');
        } catch (error) {
            console.error(" Error converting file:", error);
            setUploadStatus(`Error: ${error.message || 'Unknown error occurred'}`);
            setIsUploadAllowed(false);
        } finally {
            setLoading(false);
        }
    };

    const handleSheetSelection = async (sheetName) => {
        setSelectedSheet(sheetName); // Update selected sheet state

        if (selectedFile && sheetData[sheetName]) {
            setaftersheetname(selectedFile.name);
            const sheetContent = sheetData[sheetName];
            if (!sheetContent || sheetContent.length === 0) {
                console.warn(" Selected sheet is empty, trying again...");
                setPreviewData([]);
                setShowModal(true);
                return;
            }

            // Extract headers
            const headers = sheetContent[0]; // First row as headers
         
            const formattedCsvData = [
                headers.map(value => {
                    const str = String(value).replace(/"/g, '""');
                    return str.includes(",") ? `"${str}"` : str;
                }).join(","),
                ...sheetContent.slice(1).map((row) =>
                    row.map(value => {
                        const str = String(value).replace(/"/g, '""');
                        return str.includes(",") ? `"${str}"` : str;
                    }).join(",")
                ),
            ].join("\n");



            const originalFileName = selectedFile.name.replace(/\.[^.]+$/, ""); // Keep original name
            const csvFile = new File([formattedCsvData], `${originalFileName}.csv`, {
                type: "text/csv",
            });


            // Pass the final CSV file into handleFileChange
            handleFileChange({ target: { files: [csvFile] } });
        }
    };


    const extractWorksheets = async (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = async (e) => {
                try {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: "array" });

                    // Extract sheet names
                    const sheetNames = workbook.SheetNames;

                    // Extract data from each sheet
                    const sheetsData = sheetNames.reduce((acc, sheetName) => {
                        const worksheet = workbook.Sheets[sheetName];
                        const sheetData = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: "" }); // Keeps empty values

                        // Ensure all rows have the same number of columns
                        const maxColumns = Math.max(...sheetData.map(row => row.length));
                        const normalizedData = sheetData.map(row => [...row, ...Array(maxColumns - row.length).fill("")]);

                        acc[sheetName] = normalizedData;
                        return acc;
                    }, {});

                    resolve({ sheetNames, sheetsData });
                } catch (error) {
                    reject(error);
                }
            };
            reader.onerror = (err) => reject(err);
            reader.readAsArrayBuffer(file);
        });
    };

    const convertSqlToTxt = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            const headerMapping = {
                col_name: "COLUMN_NAME",
                col_type: "COLUMN_TYPE",
                col_length: "COLUMN_LENGTH",
                col_label: "COLUMN_LABEL",
                col_key: "COLUMN_KEY",
                // col_rename: "COLUMN_RENAME",
                // col_active: "COLUMN_ACTIVE",
                col_functions: "COLUMN_FUNCTIONS"
            };

            reader.onload = (event) => {
                try {
                    const sqlContent = event.target.result;
                    const lines = sqlContent
                        .replace(/\r?\n/g, ' ')
                        .replace(/\s+/g, ' ')
                        .trim();

                    if (!lines) {
                        setShowNoDataModal(true);
                        setIsUploadAllowed(false);
                        return reject(new Error('No content in file'));
                    }

                    const tableDefinition = lines.match(/CREATE TABLE \w+\s*\((.+)\)/i);

                    if (!tableDefinition) {
                        setModalMessage('Invalid (or) Incorrect SQL file format. CREATE TABLE statement is not found.');
                        setMessageType('danger');
                        setShowNotifyModal(true);
                        setIsUploadAllowed(false);
                        return reject(new Error('Invalid SQL file format'));
                    }
                    function splitColumns(definitionStr) {
                        const columns = [];
                        let current = '';
                        let parenDepth = 0;

                        for (let char of definitionStr) {
                            if (char === '(') parenDepth++;
                            if (char === ')') parenDepth--;

                            if (char === ',' && parenDepth === 0) {
                                columns.push(current.trim());
                                current = '';
                            } else {
                                current += char;
                            }
                        }
                        if (current) columns.push(current.trim());
                        return columns;
                    }

                    // let columnDefinitions = tableDefinition[1].split(',').map(col => col.trim());
                    let columnDefinitions = splitColumns(tableDefinition[1]);

                    let primaryKeys = [];
                    let foreignKeys = [];
                    let extractedColumns = [];
                    let reportingDateAsPrimaryKey = false;

                    const primaryKeyMatch = lines.match(/PRIMARY KEY\s*\(([^)]+)\)/i);
                    if (primaryKeyMatch) {
                        primaryKeys = primaryKeyMatch[1].split(',').map(pk => pk.trim());
                        columnDefinitions = columnDefinitions.filter(col =>
                            !col.toUpperCase().startsWith("PRIMARY KEY") &&
                            !col.toUpperCase().startsWith("FOREIGN KEY")
                        );
                    }

                    const foreignKeyMatches = lines.match(/FOREIGN KEY\s*\(([^)]+)\)\s*REFERENCES\s*\w+\s*\(([^)]+)\)/gi);
                    if (foreignKeyMatches) {
                        foreignKeyMatches.forEach(fk => {
                            const fkMatch = fk.match(/FOREIGN KEY\s*\(([^)]+)\)\s*REFERENCES\s*\w+\s*\(([^)]+)\)/i);
                            if (fkMatch) {
                                const fkColumns = fkMatch[1].split(',').map(col => col.trim());
                                const refColumns = fkMatch[2].split(',').map(col => col.trim());
                                foreignKeys.push({ fkColumns, refColumns });
                            }
                        });
                    }

                    const allowedColTypes = ['int', 'varchar', 'date', 'double', 'boolean', 'decimal', 'float', 'char', 'datetime'];
                    let invalidColKeyErrors = [];




                    columnDefinitions.forEach((column, rowIndex) => {

                        // const columnMatch = column.match(/^(\w+)\s+([a-zA-Z]+(?:\s*\([^)]+\))?)\s*(.*)/i);
                        const columnMatch = column.match(/^([^\s]+)\s+([a-zA-Z]+(?:\s*\([^)]+\))?)\s*(.*)/i);



                        if (columnMatch) {
                            const [_, col_name, col_type_raw, attributes] = columnMatch;
                            const col_length_match = col_type_raw.match(/\((\d+(?:,\d+)?)\)/);
                            const col_length = col_length_match ? col_length_match[1] : '';
                            const col_type = col_type_raw.split('(')[0].toLowerCase();
                            // Validate column name based on regex
                            if (!/^[A-Za-z0-9_]+$/.test(col_name)) {
                                invalidColKeyErrors.push(
                                    `Row ${rowIndex + 1}: Column name "${col_name}" is invalid. Only A-Z, a-z, 0-9, and underscores (_) are allowed.`
                                );
                            }

                            const isPrimaryKey = primaryKeys.map(pk => pk.toLowerCase()).includes(col_name.toLowerCase());
                            const isForeignKey = foreignKeys.some(fk =>
                                fk.fkColumns.map(col => col.toLowerCase()).includes(col_name.toLowerCase())
                            );

                            let col_key = isPrimaryKey
                                ? 'PRIMARY KEY'
                                : isForeignKey
                                    ? 'FOREIGN KEY'
                                    : attributes.includes('NOT NULL')
                                        ? 'NOT NULL'
                                        : 'NULL';

                            if (isPrimaryKey && col_name.toLowerCase() === "reporting_date") {
                                reportingDateAsPrimaryKey = true;
                            }

                            if (
                                col_name.toLowerCase() === "reporting_date" &&
                                (col_key === "NOT NULL" || col_key === "NULL")
                            ) {
                                invalidColKeyErrors.push(
                                    `Row ${rowIndex + 1}: <strong>Reporting Date</strong> cannot be NOT NULL or NULL, it should be <strong>PRIMARY KEY</strong>.`
                                );
                            }

                            let dropdownFunctions = [];
                            if (attributes.includes('dropdown')) {
                                const dropdownMatches = attributes.match(/dropdown\((\w+)\)/g);
                                if (dropdownMatches) {
                                    dropdownMatches.forEach(dropdown => {
                                        const dropdownValue = dropdown.match(/dropdown\((\w+)\)/)[1];
                                        dropdownFunctions.push(`dropdown(${dropdownValue})`);
                                    });
                                }
                            }


                            // Add this new condition block here
                            if (['decimal', 'float', 'double'].includes(col_type)) {
                                if (!col_length.includes(',')) {
                                    invalidColKeyErrors.push(
                                        // `Row ${rowIndex + 1}: ${col_name} of type ${col_type} must have precision and scale (e.g., 18,2).`
                                        `COLUMN_TYPE must be <strong>precision,scale</strong> (eg: 18,2) for COLUMN_TYPE <strong>${toTitleCase(col_type)}</strong> at <strong>Row ${rowIndex + 1}</strong> (${toTitleCase(col_name)}).`
                                    );

                                } else {
                                    const [precisionStr, scaleStr] = col_length.split(',');
                                    const precision = parseInt(precisionStr.trim());
                                    const scale = parseInt(scaleStr.trim());

                                    if (isNaN(precision) || isNaN(scale)) {
                                        invalidColKeyErrors.push(
                                            // `Row ${rowIndex + 1}: ${col_name} has invalid precision/scale values.`
                                            `COLUMN_TYPE must be <strong>precision,scale</strong> (eg: 18,2) for COLUMN_TYPE <strong>${toTitleCase(col_type)}</strong> at <strong>Row ${rowIndex + 1}</strong> (${toTitleCase(col_name)}).`

                                        );
                                    } else if (precision < scale) {
                                        invalidColKeyErrors.push(
                                            // `Row ${rowIndex + 1}: ${col_name} has precision less than scale.`
                                            `COLUMN_TYPE must be <strong>precision,scale</strong> (eg: 18,2) for COLUMN_TYPE <strong>${toTitleCase(col_type)}</strong> at <strong>Row ${rowIndex + 1}</strong> (${toTitleCase(col_name)}).`

                                        );
                                    }
                                }
                            }

                            if (col_type === 'int' && col_length === '') {
                                invalidColKeyErrors.push(
                                    // `Row ${rowIndex + 1}: ${col_name} of type INT must have a length value (e.g., INT(8)).`
                                    `COLUMN_LENGTH must be a Number for COLUMN_TYPE <strong>Int</strong> at <strong>Row ${rowIndex + 1}</strong> (${toTitleCase(col_name)})`
                                );
                            }


                            if (!allowedColTypes.includes(col_type)) {
                                setModalMessage(
                                    // `Invalid column type for ${col_name}: ${col_type}. Allowed types are: ${allowedColTypes.join(', ')}`
                                    `Invalid (or) Incorrect COLUMN_TYPE ${toTitleCase(col_type)} found at <strong>Row ${rowIndex + 1}</strong> (${toTitleCase(col_type)})`
                                );
                                setMessageType('danger');
                                setShowNotifyModal(true);
                                setIsUploadAllowed(false);
                            }

                            extractedColumns.push({
                                col_name,
                                col_type,
                                col_length,
                                col_label: col_name.replace(/_/g, ' ').toUpperCase(),
                                col_key,
                                col_rename: '',
                                col_active: '',
                                col_functions: dropdownFunctions.join(', ') || ''
                            });
                        }
                    });


                    let errorMessages = [...invalidColKeyErrors];

                    extractedColumns.forEach(col => {
                        if (!col.col_name || !col.col_type || !col.col_label) {
                            errorMessages.push(`Mandatory Column(s) Missing for <strong>${toTitleCase(col.col_name)}</strong>`);
                        }

                        if (!allowedColTypes.includes(col.col_type)) {
                            errorMessages.push(`Invalid (or) Incorrect COLUMN_TYPE <strong>${toTitleCase(col.col_type)}<strong> found in Column (<strong>${toTitleCase(col.col_name)}<strong>)`);
                        }

                        if (col.col_key === 'PRIMARY KEY' && !primaryKeys.includes(col.col_name)) {
                            errorMessages.push(`Column <strong>${toTitleCase(col.col_name)}</strong> is marked as <strong>PRIMARY KEY</strong> but not in PRIMARY KEY list`);
                        }

                        if (col.col_key === 'FOREIGN KEY' && !foreignKeys.some(fk => fk.fkColumns.map(col => col.toLowerCase()).includes(col.col_name.toLowerCase()))) {
                            errorMessages.push(`Column <strong>${toTitleCase(col.col_name)}</strong> is marked as <strong>FOREIGN KEY</strong> but not in any FOREIGN KEY constraint list`);
                        }
                    });

                    const primaryKeySet = new Set(primaryKeys);
                    if (primaryKeySet.size !== primaryKeys.length) {
                        errorMessages.push(`Duplicate entry found. Provide a Unique name`);
                    }

                    if (primaryKeys.length === 0) {
                        errorMessages.push('No <strong>Primary Key</strong> Column found in the Template');
                    }

                    if (primaryKeys.length === 1 && primaryKeys.map(pk => pk.toLowerCase()).includes('reporting_date')) {
                        errorMessages.push('Include an additional <strong>Primary Key</strong> Column, other than Reporting Date');
                    }

                    const columnNames = extractedColumns.map(col => col.col_name.toLowerCase());

                    primaryKeys.forEach(pk => {
                        if (!columnNames.includes(pk.toLowerCase())) {
                            const formattedPk = toTitleCase(pk); // Apply title case only for message
                            errorMessages.push(`Column <strong>${formattedPk}</strong> defined as PRIMARY KEY is not present in the table columns. Please check the column names.`);
                        }
                    });


                    if (errorMessages.length) {
                        const combinedErrorMessage =
                            errorMessages.length === 1
                                ? errorMessages[0]
                                : errorMessages.slice(0, -1).join(', ') + ' and ' + errorMessages.slice(-1);

                        setModalMessage(combinedErrorMessage);
                        setMessageType("danger");
                        setShowNotifyModal(true);
                        setIsUploadAllowed(false);
                        return reject(new Error(combinedErrorMessage));
                    }

                    if (!reportingDateAsPrimaryKey) {
                        setModalMessage("COLUMN_NAME <strong>Reporting Date</strong> is missing. Include if it's Required.");
                        setMessageType("warning");
                        setShowNotifyModal(true);
                        setIsUploadAllowed(true);
                    }

                    const txtContent = extractedColumns.map(col =>
                        `${col.col_name}|${col.col_type}|${col.col_length}|${col.col_label}|${col.col_key}|${col.col_rename}|${col.col_active}|${col.col_functions}`
                    ).join('\n');

                    const txtContent1 = extractedColumns.map(col =>
                        `${col.col_name}|${col.col_type}|${col.col_length}|${col.col_label}|${col.col_key}|${col.col_functions}`
                    ).join('\n');


                    const previewHeaders = Object.keys(headerMapping)
                        .map(key => headerMapping[key])
                        .join('|');

                    setPreviewData([
                        previewHeaders,
                        ...txtContent1.split('\n')
                    ]);
                    setIsUploadAllowed(true);
                    resolve(txtContent);
                } catch (error) {
                    handleError('Error processing SQL file');
                    setIsUploadAllowed(false);
                    reject(new Error('Error processing SQL file'));
                }
            };

            reader.onerror = () => {
                handleError('Error reading SQL file');
                setIsUploadAllowed(false);
                reject(new Error('Error reading SQL file'));
            };

            reader.readAsText(file);
        });
    };


    const handleFormSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission behavior

        if (!file) {
            setFileSelectionMessage('Please select a valid file.');
            setShowFileSelectionModal(true); // Show the modal with the message
            setLoading(false);
            return;
        }

        if (!isUploadAllowed) {
            setFileSelectionMessage('File validation failed. Please correct the errors and try again.');
            setShowFileSelectionModal(true);
            return;
        }

        await handleUploadAndNotify();
    };

    const handleUploadAndNotify = async () => {
        try {
            setLoading(true);

            const formData = new FormData();
            formData.append('file', file);

            // const uploadResponse = await axios.post('http://172.16.119.156:3001/uploads', formData, {
            const uploadResponse = await axios.post(upload3001, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'userId': localStorage.getItem('userid'),
                   // 'sessionId': sessionId,
                    "x-csrf-token": csrfToken
                },
                withCredentials: true,
            });

            if (uploadResponse.status === 200) {
                const fileName = file.name;
                const fileNameNoExt = fileName.replace('.txt', '');
                const filePath = "/saswork/nas/";
                await callAdditionalApi(fileNameNoExt, filePath);

                // Reset form after successful upload
                handleClearFile();
                setShowModal(false); // Close the preview modal if it's open
                setPreviewData([]); // Reset previewData state to clear any preview data
                // setShowNotifyModal(true);

            }
        } catch (uploadError) {
            if (uploadError.response && uploadError.response.status === 409) { // Assuming 409 Conflict for file already exists
                setUploadStatus('File already exists.');
                setShowModal(false); // Close the preview modal if open
                setPreviewData([]); // Clear preview data
                setShowNotifyModal(true); // Show notification modal for file exists
                setModalMessage(uploadError.response.data.message); // Set modal message
            } else {
                console.error('Error uploading file:', uploadError.response ? uploadError.response.data : uploadError.message);
                setUploadStatus('Error uploading file.');
            }
        } finally {
            setLoading(false);
        }
    };




    const callAdditionalApi = async (fileName, filePath) => {
        try {
            let config = {
                headers: {
                    "userId": localStorage.getItem('userid'), "x-csrf-token": csrfToken
                },
                withCredentials: true,
                params: {
                    "tableName": fileName,
                    "Notifications": "IN",
                    "templateType": "upload",
                    "path": "/saswork/nas/" + fileName + ".txt",
                    "dept": selectedDept
                }
            };

            setSelectedName(fileName);
            const response = await axios.post(Uploadtemplate, {}, config);

            // Store values only if they exist
            if (response.data.active_status && response.data.template_type) {
                localStorage.setItem('active_status', response.data.active_status);
                localStorage.setItem('template_type', response.data.template_type);
                localStorage.setItem('stage', response.data.stage);
                
            }


            // Handle different response statuses
            if (response.data.status === 'failure') {
                setModalMessage(response.data.message);
                setMessageType('danger');
                setShowNotifyModal(true);
                setShowSecondModal(false);
                setUploadSuccess(false);
            } else if (response.data.status === 'success') {
                const formattedName = toTitleCase(fileName);

                // setModalMessage(`${formattedName} Template Created Successfully.`);
                setModalMessage(`<strong>${formattedName}</strong> Template Created Successfully.`);
                setMessageType('success');
                setShowNotifyModal(true);
                setSecondModalMessage(`Click <strong>'Next'</strong> to assign <strong>${formattedName}</strong> Template to the Checker.`);
                setShowSecondModal(true);
                setUploadSuccess(true);
                // Save table name in state for use on the next page
                setSelectedTableName(fileName);
                localStorage.setItem('selectedTableName', fileName);
            } else {
                // Catch any other messages
                setModalMessage(response.data.message || "Something went wrong.");
                setMessageType('danger');
                setShowNotifyModal(true);
                setShowSecondModal(false);
            }

            setUploadStatus();

        } catch (error) {
            setModalMessage('An error occurred while processing your request.');
            setMessageType('danger');
            setShowNotifyModal(true);
            setShowSecondModal(false);
            console.error('Error in additional API call:', error.response ? error.response.data : error.message);
        }
    };

    const handleClearFile = () => {
        setSelectedFile(null);
        setFile(null);
        setUploadSuccess(false);
        setErrMsg('');
        setPreviewData([]);
    };

    const handleBack = () => {
        if (modalMessage === 'Template Uploaded Successfully') {
            navigate('/gapsyAdashboard');
            setShowNotifyModal(true);
        } else if (messageType !== 'warning') {
            // Only clear if messageType is not warning
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }

            setSelectedFile(null);
            setWorksheets([]);
            setSelectedDept('');
            setDepartments([]);
            setSelectedSheet('');
            setImportRow(1);
            setIncludeHeaders(true);
            setSelectedFormat('');
            setPreviewData([]);
            setShowModal(false);
            setShowNoDataModal(false);
            setShowNotifyModal(false);
        } else {
            // Just close the modal in case of warning
            setShowNotifyModal(false);

        }
    };


    const handleDashboard = () => {
        navigate('/gapsyAdashboard');
        // navigate('/DemuploadAdmin');
        // navigate('/DEMAdmin'); 
    };

    const downloadtemp = async () => {
        try {
            let filePath = "";
            let fileName = "";
            let mimeType = "";

            if (selectedFormat === "Text Files") {
                if (selectedTextFormat === "csv") {
                    filePath = "/downloads/sampletemp.csv";
                    fileName = "template.csv";
                    mimeType = "text/csv";
                } else if (selectedTextFormat === "tsv" || selectedTextFormat === "txt") {
                    filePath = "/downloads/sampletemplatetxt.txt"; // Always download TXT for TSV
                    fileName = "template.txt"; // Keep the file as .txt
                    mimeType = "text/plain"; // Keep MIME type as plain text
                }
            } else if (selectedFormat === "MySQL File") {
                if (selectedOtherFormat === "sql") {
                    filePath = "/downloads/sampletemplate.sql";
                    fileName = "template.sql";
                    mimeType = "application/sql";
                } else if (selectedOtherFormat === "txt") {
                    filePath = "/downloads/sampletemplatetxt.txt";
                    fileName = "template.txt";
                    mimeType = "text/plain";
                }
            } else if (selectedFormat === "Microsoft Excel") {
                filePath = "/downloads/sampletemp.csv"; // Download CSV first, convert to Excel later
            }

            if (!filePath) {
                setErrorMessage("Invalid file format selected.");
                return;
            }

            // const response = await fetch(`${PortURL}${filePath}`);
             const response = await fetch(`${filePath}`);


            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Error ${response.status}: ${errorText}`);
            }

            // If it's a text format (CSV or TXT), download directly
            if (selectedFormat === "Text Files" || selectedFormat === "MySQL File") {
                const fileData = await response.blob();
                const url = URL.createObjectURL(fileData);
                const link = document.createElement("a");
                link.href = url;
                link.download = fileName;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                setErrorMessage("");
                return;
            }

            // Convert CSV to Microsoft format
            const csvText = await response.text();
            const rows = csvText.split("\n").map((row) => row.replace(/"/g, "").split(",")); // Parse CSV

            // Convert CSV to Microsoft format
            const worksheet = XLSX.utils.aoa_to_sheet(rows);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

            // Determine Microsoft format
            let fileExtension = selectedMicrosoftFormat || "xls";
            switch (fileExtension) {
                case "xls":
                    mimeType = "application/vnd.ms-excel";
                    break;
                case "xlsx":
                    mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                    break;
                case "xlsm":
                    mimeType = "application/vnd.ms-excel.sheet.macroEnabled.12";
                    break;
                case "xlsb":
                    mimeType = "application/vnd.ms-excel.sheet.binary.macroEnabled.12";
                    break;
                default:
                    mimeType = "application/vnd.ms-excel";
            }

            // Convert to selected Microsoft format
            const excelBuffer = XLSX.write(workbook, {
                bookType: fileExtension,
                type: "array",
            });

            // Download the converted file
            const blob = new Blob([excelBuffer], { type: mimeType });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `template.${fileExtension}`;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setErrorMessage("");
        } catch (error) {
            console.error("Error downloading template:", error);
            setErrorMessage(error.message);
        }
    };

    const handleSecondModalNext = () => {
        setShowSecondModal(false);
        navigate('/gapsyTempAssign');
    };
    const handleCancel = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }

        setSelectedFile(null);
        setWorksheets([]);
        setSelectedSheet('');
        setImportRow(1);
        setIncludeHeaders(true);
        setSelectedFormat('');
        setPreviewData([]);
        setShowModal(false);
        setShowNoDataModal(false);
    };

    useEffect(() => {
        const calculateDangerCount = () => {
            let invalidColumns = [];

            previewData.slice(1).forEach((row, index) => { // Skipping the first row
                const columns = row.split('|');
                const columnFunctions = columns[columns.length - 1];

                const isValid = validateRow(columnFunctions, dropdownValues);

                if (!isValid) {
                    invalidColumns.push(`Row ${index + 1}`);
                }
            });
        };

        calculateDangerCount();
    }, [previewData, dropdownValues]);



    useEffect(() => {
        const calculateDangerCount = () => {
            let invalidColumns = [];

            previewData.slice(1).forEach((row, index) => { // Skipping the first row
                const columns = row.split('|');
                const columnFunctions = columns[columns.length - 1];

                const isValid = validateXMLRow(columnFunctions, dropdownValues);

                if (!isValid) {
                    invalidColumns.push(`Row ${index + 1}`);
                }
            });
        };

        calculateDangerCount();
    }, [previewData, dropdownValues]);


    const formatMappings = {
        "Microsoft Excel": ".xls, .xlsx, .xlsm, .xlsb,",
        "Text Files": ".txt,.psv,.csv",
        "MySQL File": ".sql",
    };


    const handleMicrosoftFormatSelection = (format) => {
        setSelectedMicrosoftFormat(format);
        setShowMicrosoftDropdown(false); // Hide dropdown after selection
    };



    const handleTextFormatSelection = (format) => {
        setSelectedTextFormat(format);
        setShowTextDropdown(false);
    };

    const handleOtherFormatSelection = (format) => {
        setSelectedOtherFormat(format);
        setShowOtherDropdown(false);
    };

    const microsoftFileFormats = ["xls", "xlsx", "xlsm", "xlsb"];
    const textFileFormats = ["csv", "txt"];
    const otherFileFormats = ["sql"];


    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />

            {/* Breadcrumb */}
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className={`breadcrumb-item`}>
                                    <a onClick={handleDashboard} className={`text-dark ${styles.breadcrumbLink}`}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                    </a>
                                    {/* <span className={styles.separator}>/</span> */}
                                </li>
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi bi-file-code me-2"></i>1.1 File Based Creation
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>

            {/* Main Section */}
            <main className="flex-grow-1 container-fluid">
                <div className="container-fluid">
                    <div className={`${styles.containerRow} row`}>
                        <div className="position-relative">
                            <h6 className={`${styles.borderBottom}`}>File Based Creation</h6>

                            {selectedFile && departments.length > 0 && (

                                <div className="table-on-homepage-only">
                                    <FbcDepartmentDropdown
                                        selectedDept={selectedDept}
                                        departments={departments}
                                        setSelectedDept={setSelectedDept}
                                        showDropdown={!!selectedFile}
                                    />
                                </div>
                            )}
                        </div>

                        {/* Left - File Format Options */}
                        <div className={`mb-3 ${styles.supportedFileFormats}`} style={{ minHeight: "250px", width: "35.83%" }}>
                            <span className={styles.subheading}>Select a File Format : </span>
                            <div className="d-flex gap-4 mt-2">
                                {["Microsoft Excel", "Text Files", "MySQL File"].map((format) => {
                                    const isSelected = selectedFormat === format;

                                    const iconDetails = {
                                        "Microsoft Excel": {
                                            icon: "bi-file-earmark-excel-fill",
                                            color: "text-success",
                                            label: "Excel",
                                            tooltip: "Microsoft Excel Formats",
                                        },
                                        "Text Files": {
                                            icon: "bi-filetype-csv",
                                            color: "text-primary",
                                            label: "Text",
                                            tooltip: "Text or CSV Files",
                                        },
                                        "MySQL File": {
                                            icon: "bi-database-fill-gear",
                                            color: "text-warning",
                                            label: "MySQL",
                                            tooltip: "MySQL Dump File",
                                        },
                                    };

                                    const { icon, color, label, tooltip } = iconDetails[format];

                                    return (
                                        <div
                                            key={format}
                                            role="button"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title={tooltip}
                                            onClick={() => handleFormatSelection(format)}
                                            className={`d-flex flex-column align-items-center justify-content-center p-2 border rounded ${isSelected ? "border-primary bg-light" : "border-secondary"
                                                } ${styles.iconFormatOption}`}
                                            style={{
                                                cursor: "pointer",
                                                width: "80px",
                                                transition: "transform 0.2s ease-in-out",
                                            }}
                                        >
                                            <i className={`bi ${icon} fs-2 ${color}`}></i>
                                            <span className="small text-dark text-center mt-1">{label}</span>
                                        </div>
                                    );
                                })}
                            </div>


                            {selectedFormat && (
                                <div
                                    style={{
                                        minHeight: "80px",
                                        visibility: selectedFormat ? "visible" : "hidden"
                                    }}
                                >

                                    <div className="d-flex flex-column mt-3">
                                        {selectedFormat && showDownloadButton && !selectedFile && (
                                            <>
                                                {/* Error message aligned above buttons */}
                                                {errorMessage && (
                                                    <div className="text-danger mb-2">
                                                        {errorMessage}
                                                    </div>
                                                )}

                                                {/* Download buttons aligned in a row */}
                                                <div className="d-flex gap-3">
                                                    {/* Excel Format Dropdown */}
                                                    {selectedFormat === "Microsoft Excel" && (
                                                        <div
                                                            className="custom-dropdown"
                                                            onMouseEnter={() => setShowMicrosoftDropdown(true)}
                                                            onMouseLeave={() => setShowMicrosoftDropdown(false)}
                                                        >
                                                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                                                <button
                                                                    className={`btn btn-sm btn-download ${selectedMicrosoftFormat ? "btn-primary text-white" : ""}`}
                                                                    onClick={downloadtemp}
                                                                >
                                                                    <i className="bi bi-download"></i>
                                                                    {selectedMicrosoftFormat ? ` Download (.${selectedMicrosoftFormat})` : " Download"}
                                                                </button>

                                                                {selectedFormat && showDownloadButton && !selectedFile && (
                                                                    <p className="mb-0 fst-italic fw-normal">Download the format to create the template</p>
                                                                )}
                                                            </div>

                                                            {showMicrosoftDropdown && (
                                                                <ul className="custom-dropdown-menu">
                                                                    {microsoftFileFormats.map((format) => (
                                                                        <li key={format}>
                                                                            <button
                                                                                className="custom-dropdown-item"
                                                                                onClick={() => handleMicrosoftFormatSelection(format)}
                                                                            >
                                                                                .{format}
                                                                            </button>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            )}
                                                        </div>
                                                    )}

                                                    {/* Text Format Dropdown */}
                                                    {selectedFormat === "Text Files" && (
                                                        <div
                                                            className="custom-dropdown"
                                                            onMouseEnter={() => setShowTextDropdown(true)}
                                                            onMouseLeave={() => setShowTextDropdown(false)}
                                                        >
                                                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                                                <button
                                                                    className={`btn btn-sm btn-download ${selectedTextFormat ? "btn-primary text-white" : ""}`}
                                                                    onClick={downloadtemp}
                                                                >
                                                                    <i className="bi bi-download"></i>
                                                                    {selectedTextFormat ? ` Download (.${selectedTextFormat})` : " Download"}
                                                                </button>
                                                                {selectedFormat && showDownloadButton && !selectedFile && (
                                                                    <p className="mb-0 fst-italic fw-normal">Download the format to create the template</p>
                                                                )}
                                                                {showTextDropdown && (
                                                                    <ul className="custom-dropdown-menu">
                                                                        {textFileFormats.map((format) => (
                                                                            <li key={format}>
                                                                                <button
                                                                                    className="custom-dropdown-item"
                                                                                    onClick={() => handleTextFormatSelection(format)}
                                                                                >
                                                                                    .{format}
                                                                                </button>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* MySQL Format Dropdown */}
                                                    {selectedFormat === "MySQL File" && (
                                                        <div
                                                            className="custom-dropdown"
                                                            onMouseEnter={() => setShowOtherDropdown(true)}
                                                            onMouseLeave={() => setShowOtherDropdown(false)}
                                                        >
                                                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                                                <button
                                                                    className={`btn btn-sm btn-download ${selectedOtherFormat ? "btn-primary text-white" : ""}`}
                                                                    onClick={downloadtemp}
                                                                >
                                                                    <i className="bi bi-download"></i>
                                                                    {selectedOtherFormat ? ` Download (.${selectedOtherFormat})` : " Download"}
                                                                </button>
                                                                {selectedFormat && showDownloadButton && !selectedFile && (
                                                                    <p className="mb-0 fst-italic fw-normal">Download the format to create the template</p>
                                                                )}
                                                                {showOtherDropdown && (
                                                                    <ul className="custom-dropdown-menu">
                                                                        {otherFileFormats.map((format) => (
                                                                            <li key={format}>
                                                                                <button
                                                                                    className="custom-dropdown-item"
                                                                                    onClick={() => handleOtherFormatSelection(format)}
                                                                                >
                                                                                    .{format}
                                                                                </button>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                    {worksheets.length > 0 && selectedFile && selectedFormat === "Microsoft Excel" && (
                                        <div
                                            className="custom-dropdown-sheet"
                                            onMouseEnter={() => setShowSheetDropdown(true)}
                                            onMouseLeave={() => setShowSheetDropdown(false)}
                                        >
                                            {/* Sheet Selection Button */}
                                            <button
                                                className="btn btn-outline-secondary btn-sm dropdown-toggle"
                                                type="button"
                                                id="dropdownMenuButtonSheet"
                                            >
                                                {selectedSheet ? selectedSheet : "Select Sheet"}
                                            </button>

                                            {/* Dropdown Menu */}
                                            {showSheetDropdown && (
                                                <ul className="custom-dropdown-menu-sheet">
                                                    {worksheets.map((sheet, index) => (
                                                        <li key={index}>
                                                            <button
                                                                className="custom-dropdown-item-sheet"
                                                                onClick={() => {
                                                                    handleSheetSelection(sheet);
                                                                    setShowSheetDropdown(false); // Close dropdown on selection
                                                                }}
                                                            >
                                                                {sheet}
                                                            </button>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    )}

                                </div>
                            )}

                        </div>

                        {/* Right - Dynamic Info + Upload */}
                        <div className="col-md-6 mb-2 mt-1">

                            {/* Hidden file input */}
                            <input
                                type="file"
                                className="d-none"
                                ref={fileInputRef}
                                // onChange={handleFileSelect}
                                onClick={handleBrowseClick}

                            />

                            {/* Drag-and-drop area */}
                            <div className="gapsybdmupload-page">
                                <div className={`p-2 ${styles.uploadArea}`}>
                                    <div
                                        className={`rounded-3 p-3 text-center mt-2 ${(!selectedFormat) ? "text-muted" : ""}`}
                                        style={{
                                            // borderStyle: isDragging ? "dashed" : "dotted",
                                            borderColor: "#ced4da",
                                            borderWidth: "2px",
                                            borderRadius: "10px",
                                            cursor: (!selectedFormat) ? "not-allowed" : "pointer",
                                            transition: "border 0.2s ease",
                                            opacity: (!selectedFormat) ? 0.5 : 1,
                                            background: "transparent",
                                            minHeight: "180px",
                                        }}
                                        onClick={() => {
                                            if (selectedFormat) {
                                                fileInputRef.current?.click();
                                            }
                                        }}
                                        onDragOver={(e) => {
                                            if (selectedFormat) {
                                                e.preventDefault();
                                                setIsDragging(true);
                                            }
                                        }}
                                        onDragLeave={() => setIsDragging(false)}
                                        onDrop={(e) => {
                                            if (selectedFormat) {
                                                e.preventDefault();
                                                setIsDragging(false);
                                                handleFileDrop(e);
                                            }
                                        }}
                                    >
                                        <i className="bi bi-cloud-upload fs-1 text-muted mb-2 d-block text-center"></i>
                                        <h5 className="mb-1">Upload File</h5>
                                        <p className="text-muted mb-0">Click to browse</p>
                                    </div>
                                </div>
                            </div>

                            <input
                                type="file"
                                ref={fileInputRef}
                                className="custom-hidden-file-input"
                                onChange={(event) => {
                                    handleFileChange(event);
                                    anotherFunction(event);
                                }}
                                accept={selectedFormat ? formatMappings[selectedFormat] : ""}
                            />

                            {/* Show file info and buttons */}
                            {selectedFile && (
                                <div className="mt-2">
                                    <div className="d-flex justify-content-between align-items-center border rounded px-3 py-2" style={{ backgroundColor: '#007bff', color: 'white', boxShadow: '0 2px 6px rgba(0,0,0,0.1)' }}>
                                        <div>
                                            <strong>{selectedFile.name}</strong> <br />
                                            <small className="text-light">{(selectedFile.size / 1024).toFixed(2)} KB</small>
                                        </div>
                                        <button
                                            className="btn btn-sm btn-close btn-close-white"
                                            onClick={handleCancel}
                                            aria-label="Cancel"
                                        />
                                    </div>

                                    {/* Centered buttons */}
                                    <div className="d-flex justify-content-center gap-3 mt-2">
                                        <div
                                            title={
                                                selectedDept === ""
                                                    ? "Please select the department and preview"
                                                    : selectedFormat === "Microsoft Excel" && !selectedSheet
                                                        ? "Please select a sheet"
                                                        : ""
                                            }
                                        >
                                            <button
                                                className="btn btn-outline-primary btn-sm"
                                                onClick={handlePreviewOption}
                                                disabled={
                                                    selectedDept === "" ||
                                                    (selectedFormat === "Microsoft Excel" && !selectedSheet)
                                                }
                                            >
                                                Preview
                                            </button>
                                        </div>

                                        <div title={selectedDept === "" ? "Please select the department and upload" : ""}>
                                            <button
                                                className="btn btn-outline-success btn-sm"
                                                onClick={handleFormSubmit}
                                                disabled={selectedDept === ""}
                                            >
                                                Upload
                                            </button>
                                        </div>
                                        <button className="btn btn-outline-secondary btn-sm" onClick={handleCancel}>
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            </main>


            <Modal
                show={showModal}
                dialogClassName="modal-xl"
                centered
            >
                <Modal.Header className="bg-light border-bottom px-0 py-2">
                    <div className="container-fluid px-0">
                        <div className="row align-items-center w-100 gx-0">
                            {/* Left-aligned Table Name */}
                            <div className="col-auto ps-3">
                                <h6 className="mb-0">
                                    <strong>Template Preview</strong>
                                </h6>
                            </div>

                            {/* Center-aligned Validation Text */}
                            <div className="col text-center">
                                {dangerCount > 0 ? (
                                    <div className="text-danger fw-semibold" role="alert">
                                        {dangerCount} rows are missing required dropdown values.
                                    </div>
                                ) : (
                                    <div className="text-success fw-semibold" role="alert">
                                        ✅ Validated Successfully
                                    </div>
                                )}
                            </div>

                            {/* Right-aligned Close Button */}
                            <div className="col-auto">
                                <div className="d-flex justify-content-end pe-3">
                                    <button
                                        onClick={handleCloseModal}
                                        type="button"
                                        className="btn-close"
                                        aria-label="Close"
                                    ></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '65vh', overflowY: 'auto' }}>
                    {previewData.length > 0 ? (
                        <>
                            <div className='table-on-homepage-only'>
                                <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                    <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>
                                        <thead>
                                            <tr>
                                                {previewData[0]
                                                    .split('|')
                                                    .filter(header => header !== 'col_rename' && header !== 'col_active')
                                                    .map((header, index) => <th key={index}>{header}</th>)}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {previewData.slice(1, previewLimit + 1).map((row, rowIndex) => {
                                                const columns = row.split('|');
                                                const headerColumns = previewData[0].split('|');

                                                const filteredColumns = columns.filter((_, cellIndex) =>
                                                    headerColumns[cellIndex] !== 'col_rename' && headerColumns[cellIndex] !== 'col_active'
                                                );

                                                const columnFunctions = filteredColumns[filteredColumns.length - 1];
                                                const rowClass = validateRow(columnFunctions, dropdownValues);

                                                return (
                                                    <tr key={rowIndex} className={rowClass}>
                                                        {filteredColumns.map((cell, cellIndex) => <td key={cellIndex}>{cell}</td>)}
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {previewLimit + 1 < previewData.length && (
                                <div className='table-on-homepage-only'>
                                    <div className="text-center mt-3">
                                        <Button
                                            style={submitButtonStyle}
                                            onClick={() => setPreviewLimit(previewLimit + 100)} >
                                            Load More
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </>
                    ) : (
                        <p>No preview data available.</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showErrorModal}
                onHide={() => setShowErrorModal(false)}
                centered

                style={{ marginTop: '12vh' }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Error</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p style={{ fontSize: '14px' }}>{errorModalMessage}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary"
                        style={closeButtonStyle}
                        onClick={() => setShowErrorModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showNotifyModal} onHide={() => setShowNotifyModal(false)} backdrop="static"  // <-- This prevents closing on outside click
                keyboard={false} style={{ marginTop: '12vh' }}>
                <div
                    className={`alert alert-${messageType === 'success' ? 'success' : messageType === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`}
                    role="alert"
                    style={{ marginBottom: '0' }} // Set marginBottom to 0
                >
                    <div className="d-flex align-items-center">
                        {messageType === 'success' ? (
                            <span className="me-2" style={{ color: 'green', marginBottom: '0px' }}>✅</span>
                        ) : messageType === 'warning' ? (
                            <span className="me-2" style={{ color: 'orange', marginBottom: '0px' }}>⚠️</span>
                        ) : (
                            <span className="me-2" style={{ color: 'red', marginBottom: '0px' }}>❌</span>
                        )}
                        <p
                            style={{
                                display: 'inline',
                                marginBottom: '0px',
                                fontSize: '14px',
                                color:
                                    messageType === 'success'
                                        ? 'green'
                                        : messageType === 'warning'
                                            ? 'orange'
                                            : 'red' // Change text color based on messageType
                            }}
                        >
                            {/* {modalMessage} */}
                            <div dangerouslySetInnerHTML={{ __html: modalMessage }} />

                        </p>
                    </div>

                    <button
                        type="button"
                        className="btn-close"
                        onClick={handleBack}
                        style={{ width: '15px', height: '15px', fontSize: '8px', position: 'absolute', bottom: '10px', right: '10px' }} // Adjust width, height, and position
                    ></button>
                </div>

            </Modal>


            <Modal
                show={showNoDataModal}
                onHide={handleCloseNoDataModal}
                dialogClassName="modal-narrow" // Adjust if needed
                style={{ marginTop: '12vh' }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Template Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>No preview data available. Please upload a file with valid data.</p>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className={bootstrapbuttonclass}
                        style={

                            closeButtonStyle
                        }
                        onClick={handleCloseNoDataModal}>Close</button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showSecondModal}
                onHide={() => setShowSecondModal(false)}
                centered
                backdrop="static"  // <-- This prevents closing on outside click
                keyboard={false}
            // Optional: prevents ESC key closing
            >
                <Modal.Header
                    style={{
                        backgroundColor: '#366872',
                        color: 'white',
                        padding: '0.5rem 1rem'
                    }}
                >
                    <Modal.Title style={{ fontSize: '16px' }}>
                        Select Authorization
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                    <div dangerouslySetInnerHTML={{ __html: secondModalMessage }} />
                </Modal.Body>

                <Modal.Footer
                    style={{ borderTop: 'none' }}
                >
                    <Button
                        variant="primary"
                        style={{ padding: '0.3rem 0.9rem', fontSize: '13px' }}
                        onClick={handleSecondModalNext}
                    >
                        Next
                    </Button>
                </Modal.Footer>

            </Modal>


            <Footer />
        </div>
    );
};

export default GapsyFbc;
